module.exports = __webpack_public_path__ + "static/media/image.2252b8e1.svg";